/*
* Other misc app data constants
*/

export class AppDataConstants {
    public static readonly UsefulLifeOptions = {
        NotApplicable: 'N/A',
        OneTimeExpense: '1TE',
    };
}



// WEBPACK FOOTER //
// ./src/common/app-data-constants.tsx